//
// ウィンドウリサイズObservable
//
// ウィンドウリサイズを検知し、Observerに通知を送ります。
// サービスとしてInjectされているので各コンポーネントから$windowResizeで参照できます。
//
// 使用例
// this.$windowResize.subscribe(e => {
//   console.log('resized', e) // {originalEvent: Event, windowWidth: 1424, windowHeight: 310}
// })
//

import Vue from 'vue'
import { fromEvent } from 'rxjs'
import { debounceTime, map } from 'rxjs/operators'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.windowResize) this.$windowResize = options.windowResize
    else if (options.parent && options.parent.$windowResize)
      this.$windowResize = options.parent.$windowResize
  },
})

const source = fromEvent(window, 'resize').pipe(
  debounceTime(200),
  map(e => ({
    originalEvent: e,
    windowWidth: e.target.innerWidth,
    windowHeight: e.target.innerHeight,
  })),
)

export default source
